/**
 * Editorial story strength for an audio stop.
 * Empty on the row means unassessed. Scout can fill the effective value
 * until an editor writes this column. It is not tourist importance and not
 * whether the audio file exists yet.
 */
export enum AttractionAudioPotentialEnum {
    STRONG = 'strong',
    MEDIUM = 'medium',
    LOW = 'low',
    NONE = 'none',
}

export const AUDIO_POTENTIAL_UNASSESSED = 'unassessed';
